@if (variant() === 'modal') {

  <!-- ===== Carcasa modal Ionic (app) ===== -->
  <ion-header class="app-safe-area-header bg-gray-300">
    <div class="flex items-center justify-between px-6 py-4">
      <lib-icon name="cancel" class="text-2xl text-gray-600 cursor-pointer" (click)="cancel()"></lib-icon>
      <h2 class="text-lg font-semibold text-gray-800 font-title">{{ title() }}</h2>
      @if (dirty()) {
        <lib-icon name="check-mark" class="text-2xl text-teal-500 cursor-pointer" (click)="confirm()"></lib-icon>
      } @else {
        <div class="w-6"></div>
      }
    </div>
  </ion-header>

  <ion-content class="[--background:var(--color-gray-300)]">
    <div [class.app-safe-area-fill]="!dirty()">
      <div class="px-4 py-3">
        <lib-sectors-filters
          [filters]="filters()"
          (filtersChange)="onFiltersChange($event)"
          (dirtyChange)="onDirtyChange($event)">
        </lib-sectors-filters>
      </div>
    </div>
  </ion-content>

  @if (dirty()) {
  <ion-footer class="ion-no-border app-safe-area-footer">
    <div class="bg-gray-300 px-6 py-6 flex gap-4 justify-center">
      <lib-button
        class="min-w-[134px]"
        variant="outline"
        className="bg-white border-gray-200 text-gray-700 h-12 font-title font-medium"
        (btnClick)="cancel()">
        Cancelar
      </lib-button>
      <lib-button
        class="min-w-[134px]"
        variant="primary"
        className="bg-teal-400 border-teal-400 hover:bg-teal-500 h-12 font-title font-medium"
        (btnClick)="confirm()">
        Aceptar
      </lib-button>
    </div>
  </ion-footer>
  }

} @else {

  <!-- ===== Carcasa panel responsive (web) ===== -->
  <div class="bg-white h-full overflow-y-auto flex flex-col shadow-sm border border-gray-200 rounded-xl lg:h-auto lg:max-h-full lg:overflow-hidden lg:shadow-sm lg:border lg:border-gray-200 lg:rounded-xl lg:border-b">
    <!-- Cabecera móvil con botones aceptar/cancelar -->
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex-shrink-0 flex items-center justify-between lg:hidden">
      <button class="text-gray-500 hover:text-gray-700 transition-colors" (click)="cancel()">
        <lib-icon name="cancel" class="w-6"></lib-icon>
      </button>
      <h3 class="text-lg font-semibold text-gray-800 font-title">{{ title() }}</h3>
      @if (dirty()) {
        <button class="text-teal-500 hover:text-teal-600 transition-colors" (click)="confirm()">
          <lib-icon name="check-mark" class="w-6"></lib-icon>
        </button>
      } @else {
        <div class="w-6"></div>
      }
    </div>

    <!-- Cabecera escritorio -->
    <div class="px-6 py-4 border-b border-gray-200 bg-gray-50 flex-shrink-0 hidden lg:block">
      <h3 class="text-lg font-semibold text-gray-800 font-title">{{ title() }}</h3>
    </div>

    <!-- Contenido compartido -->
    <div class="flex-1 p-6 overflow-y-auto">
      <lib-sectors-filters
        [filters]="filters()"
        (filtersChange)="onFiltersChange($event)"
        (dirtyChange)="onDirtyChange($event)">
      </lib-sectors-filters>
    </div>
  </div>

}
